import { api2 } from './ApiService';

export default class WepayService {
    
    static async get(type) {
        
        let response =  await api2.get(`/api/v1/wepay/data/${type}`)
        return response.data
    }

    static async search(key,page,perpage,start_date,end_date) {
        let data ={
            searchKey: key,
            page: page,
            perpage:perpage,
            startDate: start_date,
            endDate: end_date
        }
        let response =  await api2.post(`/api/v1/wepay/search`,data)
        return response.data
    }

 
}


// WEBPACK FOOTER //
// ./src/service/WepayService.js